import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { format } from 'owa-strings';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';
import { MailIcons } from 'mini-mail-icons';
import { MiniIcons } from 'owa-mini-icons';

export interface ViewFilterProps {
    icon: string;
    label: string;
    ariaLabel: string;
    isPressed: boolean;
}

export const getPropsForViewFilter = (viewFilter: ViewFilter = 'All'): ViewFilterProps => {
    const strings = getOwaMiniStrings();
    let icon: string = MailIcons.Filter;
    let label: string = strings.mailFilter;
    let isPressed: boolean = false;
    let ariaLabel: string = label;

    switch (viewFilter) {
        case 'Flagged':
            icon = MailIcons.Flag;
            label = strings.flaggedFilter;
            ariaLabel = format(strings.mailFilterCancelAriaLabel, strings.flaggedFilter);
            isPressed = true;
            break;
        case 'ToOrCcMe':
            icon = MailIcons.MailForward;
            label = strings.toMeFilter;
            ariaLabel = format(strings.mailFilterCancelAriaLabel, strings.toMeFilter);
            isPressed = true;
            break;
        case 'Unread':
            icon = MiniIcons.Mail;
            label = strings.unreadFilter;
            ariaLabel = format(strings.mailFilterCancelAriaLabel, strings.unreadFilter);
            isPressed = true;
            break;
        case 'Pinned':
            icon = MailIcons.Pinned;
            label = strings.pinnedFilter;
            ariaLabel = format(strings.mailFilterCancelAriaLabel, strings.pinnedFilter);
            isPressed = true;
            break;
        case 'Mentioned':
            icon = MailIcons.Accounts;
            label = strings.mentionsFilter;
            ariaLabel = format(strings.mailFilterCancelAriaLabel, strings.mentionsFilter);
            isPressed = true;
            break;
        default:
            icon = MailIcons.Filter;
            label = strings.mailFilter;
            ariaLabel = strings.mailFilter;
            isPressed = false;
            break;
    }

    return { icon, label, ariaLabel, isPressed };
};
